export const If = ({
  children,
  condition,
}: {
  children: React.ReactNode;
  condition: boolean;
}) => {
  if (condition) {
    return <>{children}</>;
  }
  return null;
};
